<template>
  <font-awesome-icon
    icon="user-cog"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserCog } from '@fortawesome/free-solid-svg-icons'

library.add(faUserCog)

export default {
  name: 'CoozzyUserCogIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
